const Rate = ELEMENT.Rate;

Object.assign(Rate.props, {
  // 图标间隙
  distance: {
    type: String,
    default: '6px'
  }
});

const getIconStyle = Rate.methods.getIconStyle;
Rate.methods.getIconStyle = function (item) {
  let res = getIconStyle.call(this, item);
  res['margin-right'] = this.distance;
  return res;
}